import React, { Component } from "react";
import RoundRow from "./RoundRow";
import { Table } from "semantic-ui-react";

const header_labels = [
  {
    label: "Round",
  },
  {
    label: "Progress",
  },
  {
    label: "Total Apps",
  },
  {
    label: "Reads Per Grader",
  },
  {
    label: "Reads Per App",
  },
  {
    label: "Deadline",
  },
];

class RoundsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    let header = header_labels.map((item) => (
      <Table.HeaderCell key={item.label}>{item.label}</Table.HeaderCell>
    ));

    //go through the rows
    let rows = [];
    for (let i = 0; i < this.props.data.length; i++) {
      let highlight = this.props.data[i].current ? "positive" : null;
      rows.push(<RoundRow data={this.props.data[i]} hl={highlight} s />);
    }

    return (
      <Table singleLine selectable>
        <Table.Header>
          <Table.Row>{header}</Table.Row>
        </Table.Header>
        <Table.Body>{rows}</Table.Body>
      </Table>
    );
  }
}

export default RoundsTable;



// WEBPACK FOOTER //
// ./src/components/admin/rounds_table/RoundsTable.js